import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../../components/Loading";
import DropdownMenu from './Dropdown'
import _ from "lodash";
import EventFormDisplay from './EventFormDisplay'
import RemoveSvg from '../../../svgs/RemoveSvg';
import QRCode from 'qrcode'
import { SHARE_BASE_URL } from "../../../config";

function Page(props) {
    const { id: eventId } = useParams();
    const [isloading, setisloading] = useState(false);
    const data = props.data?.registrationForm || []
    const qrRef = useRef(null);

    const [isShowPreview, setisShowPreview] = useState(false);

    const copyLinkToClipboard = () => {
        const link = `${SHARE_BASE_URL}/registration-form/${eventId}`;
        navigator.clipboard.writeText(link).then(() => {
            alert('報名表連結已複製到剪貼板');
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    }
    const [isShowQrcode, setisShowQrcode] = useState(false);
    useEffect(() => {
        const qrOptions = {
            scale: 8,
            color: {
                dark: '#000',  // Blue dots
                light: '#FFFFFF' // Transparent background
            }
        }
        if (isShowQrcode)
            QRCode.toCanvas(qrRef.current, `${SHARE_BASE_URL}/registration-form/${eventId}`
                , qrOptions, function (error) {
                    if (error) console.error(error)
                })
    }, [isShowQrcode])


    return (
        <div className="w-full h-full flex flex-col items-start justify-start bg-[#ddd] overflow-hidden p-[16px] gap-[8px]" style={{ overflowY: 'auto' }}>


            <div className='w-full flex flex-row justify-between items-start gap-[16px]'>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>啟用報名表</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enable ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enable: item === '啟用' })
                            }
                        }}
                    />
                </div>

                <div className="flex flex-row items-center justify-start gap-[8px]">
                    <div onClick={() => { setisShowQrcode(true) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        顯示報名表二維碼
                    </div>
                    <div onClick={copyLinkToClipboard} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        複製報名表連結
                    </div>
                    <div onClick={() => { setisShowPreview(true) }} className="cursor-pointer hover:opacity-[.5] px-[24px] py-[4px] rounded-[4px] text-[white] font-[700] text-[12px]" style={{ background: 'linear-gradient(180deg, #7F7F7F 0%, rgba(96, 96, 96, 0.2) 100%)' }}>
                        預覽報名表
                    </div>
                </div>
            </div>

            <div className="w-full flex flex-row items-center justify-start gap-[8px] flex-wrap">
                <div className="flex flex-col gap-[8px] max-w-[300px] min-w-[300px]">
                    <div className='font-[700] mt-[16px]'>報名表標題</div>
                    <input className='w-full p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                        value={props.data?.registrationForm?.title || ''}
                        onChange={(e) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), title: e.target.value })
                            }
                        }}
                    />
                </div>
            </div>
            <div className="w-full flex flex-row items-center justify-start gap-[8px] flex-wrap">
                <div className="flex flex-col gap-[8px] max-w-[300px] min-w-[300px]">
                    <div className='font-[700] mt-[16px]'>報名表副標題</div>
                    <input className='w-full p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                        value={props.data?.registrationForm?.subtitle || ''}
                        onChange={(e) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), subtitle: e.target.value })
                            }
                        }}
                    />
                </div>
            </div>
            <div className="w-full flex flex-row items-center justify-start gap-[8px] flex-wrap">
                <div className="flex flex-col gap-[8px] w-full min-w-[500px]">
                    <div className='font-[700] mt-[16px]'>描述</div>
                    <textarea className='w-full p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                        value={props.data?.registrationForm?.description || ''}
                        onChange={(e) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), description: e.target.value })
                            }
                        }}
                    />
                </div>
            </div>

            <div className="border-b-[1px] border-[#8D876C] w-full mt-[16px] mb-[8px] font-[700] text-[16px] text-[#6E604C]">
                報名資料
            </div>

            <div className="w-full flex flex-row items-start justify-start gap-[8px] flex-wrap">
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>年齡(Age)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableAge ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableAge: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>手機號(Mobile)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableMobile ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableMobile: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>微信號(Wechat ID)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableWechat ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableWechat: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>您的最高學位(Your highest degree)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableHighestDegree ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableHighestDegree: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>畢業學校及專業(School and major)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableSchoolAndMajor ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableSchoolAndMajor: item === '啟用' })
                            }
                        }}
                    />
                    <DropdownMenu options={['可選填寫','必須填寫']}
                        value={props.data?.registrationForm?.enableSchoolAndMajorMustFillIn ? '必須填寫' : '可選填寫'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableSchoolAndMajorMustFillIn: item === '必須填寫' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>畢業時間(Graduation time)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableGraduationTime ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableGraduationTime: item === '啟用' })
                            }
                        }}
                    />
                    <DropdownMenu options={['可選填寫','必須填寫']}
                        value={props.data?.registrationForm?.enableGraduationTimeMustFillIn ? '必須填寫' : '可選填寫'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableGraduationTimeMustFillIn: item === '必須填寫' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>您的工作經驗(Your work experience)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableWorkExperience ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableWorkExperience: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>目前工作單位名稱(Current employer)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableCurrentEmployer ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableCurrentEmployer: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>職位(position)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enablePosition ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enablePosition: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700] flex flex-row items-end'>
                        您的香港簽證類型
                        <div className="text-[11px]">(Your Hong Kong visa)</div>
                    </div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableHongKongVisa ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableHongKongVisa: item === '啟用' })
                            }
                        }}
                    />
                </div>
                {[1, 2, 3, 4, 5].map((item) =>
                    <div key={item} className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                        <div className='font-[700]'>是否問題{item}</div>
                        <DropdownMenu options={['啟用', '不啟用']}
                            value={props.data?.registrationForm?.[`enableExtraQuestion${item}`] ? '啟用' : '不啟用'}
                            select={(otp, index) => {
                                if (props.onEdit) {
                                    props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`enableExtraQuestion${item}`]: otp === '啟用' })
                                }
                            }}
                        />
                        {props.data?.registrationForm?.[`enableExtraQuestion${item}`] && <div className="w-full flex flex-row gap-[4px] items-center">
                            問題:
                            <input className='flex-1 p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                value={props.data?.registrationForm?.[`extraQuestion${item}`] || ''}
                                onChange={(e) => {
                                    if (props.onEdit) {
                                        props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`extraQuestion${item}`]: e.target.value })
                                    }
                                }}
                                placeholder="請輸入"
                            />
                        </div>}
                    </div>)}
                {/* multiple choice questions */}
                {[1, 2, 3, 4, 5].map((item) =>
                    <div key={item} className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                        <div className='font-[700]'>多選問題{item}</div>
                        <DropdownMenu options={['啟用', '不啟用']}
                            value={props.data?.registrationForm?.[`enableExtraMCQuestion${item}`] ? '啟用' : '不啟用'}
                            select={(otp, index) => {
                                if (props.onEdit) {
                                    props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`enableExtraMCQuestion${item}`]: otp === '啟用' })
                                }
                            }}
                        />
                        {props.data?.registrationForm?.[`enableExtraMCQuestion${item}`] && <div className="w-full flex flex-row gap-[4px] items-center">
                            問題:
                            <input className='flex-1 p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                value={props.data?.registrationForm?.[`extraMCQuestion${item}`] || ''}
                                onChange={(e) => {
                                    if (props.onEdit) {
                                        props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`extraMCQuestion${item}`]: e.target.value })
                                    }
                                }}
                                placeholder="請輸入"
                            />
                        </div>}
                        {props.data?.registrationForm?.[`enableExtraMCQuestion${item}`] && <div className="w-full flex flex-col gap-[4px]">
                            選項 (Options):
                            <input className='flex-1 p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                value={props.data?.registrationForm?.[`extraMCQuestion${item}Options`] || ''}
                                onChange={(e) => {
                                    if (props.onEdit) {
                                        props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`extraMCQuestion${item}Options`]: e.target.value })
                                    }
                                }}
                                placeholder="請以逗號分隔各選項，例如：選項一,選項二,選項三"
                            />
                        </div>}
                    </div>)}

                    {/* short questions */}
                    {[1, 2, 3, 4, 5].map((item) =>
                    <div key={item} className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                        <div className='font-[700]'>填空問題{item}</div>
                        <DropdownMenu options={['啟用', '不啟用']}
                            value={props.data?.registrationForm?.[`enableExtraShortQuestion${item}`] ? '啟用' : '不啟用'}
                            select={(otp, index) => {
                                if (props.onEdit) {
                                    props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`enableExtraShortQuestion${item}`]: otp === '啟用' })
                                }
                            }}
                        />
                        {props.data?.registrationForm?.[`enableExtraShortQuestion${item}`] && <div className="w-full flex flex-col gap-[4px] items-center">
                            <div className="w-full flex-row flex gap-[4px] items-center">
                                問題:
                                <input className='flex-1 p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                    value={props.data?.registrationForm?.[`extraShortQuestion${item}`] || ''}
                                    onChange={(e) => {
                                        if (props.onEdit) {
                                            props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`extraShortQuestion${item}`]: e.target.value })
                                        }
                                    }}
                                    placeholder="請輸入"
                                />
                            </div>
                            <div className="w-full flex-row flex gap-[4px] items-center">
                                提示:
                                <input className='flex-1 p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                    value={props.data?.registrationForm?.[`extraShortQuestion${item}Hint`] || ''}
                                    onChange={(e) => {
                                        if (props.onEdit) {
                                            props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), [`extraShortQuestion${item}Hint`]: e.target.value })
                                        }
                                    }}
                                    placeholder="請輸入"
                                />
                            </div>
                        </div>}
                    </div>)}

                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>出席環節(Attendance Session)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableAttendanceSession ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableAttendanceSession: item === '啟用' })
                            }
                        }}
                    />
                    {props.data?.registrationForm?.enableAttendanceSession && (props.data?.registrationForm?.attendanceSessions || []).map((session, index) =>
                        <div key={index} className="flex flex-row w-full gap-[4px] mt-[8px] items-center justify-between">
                            <div className='font-[700]'>環節{Number(index) + 1}:</div>
                            <input className='p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                                value={session.name || ''}
                                onChange={(e) => {
                                    if (props.onEdit) {
                                        const newSessions = [...(props.data?.registrationForm?.attendanceSessions || [])];
                                        newSessions[index].name = e.target.value;
                                        props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), attendanceSessions: newSessions })
                                    }
                                }}
                            />
                            <div className="cursor-pointer hover:opacity-[.5]" onClick={() => {
                                if (props.onEdit) {
                                    const newSessions = [...(props.data?.registrationForm?.attendanceSessions || [])];
                                    newSessions.splice(index, 1);
                                    props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), attendanceSessions: newSessions })
                                }
                            }}>
                                <RemoveSvg />
                            </div>
                        </div>
                    )}
                    <div className="flex flex-row items-start justify-start gap-[8px] mt-[8px]">
                        <div className="cursor-pointer hover:opacity-[.5] text-center rounded-[4px] text-[white] font-[700] text-[12px] bg-[#0F737E] p-[4px]" onClick={() => {
                            if (props.onEdit) {
                                if (props.data?.registrationForm?.attendanceSessions?.length >= 5) {
                                    alert('最多只能添加5個出席環節');
                                    return;
                                }
                                const newSessions = [...(props.data?.registrationForm?.attendanceSessions || []), { name: '' }];
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), attendanceSessions: newSessions })
                            }
                        }}>
                            + 出席環節
                        </div>
                    </div>
                </div>



                <div className='flex flex-col gap-[8px] max-w-[300px] min-w-[300px] justify-start '>
                    <div className='font-[700]'>上傳履歷(Upload CV)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableUploadCV ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableUploadCV: item === '啟用' })
                            }
                        }}
                    />
                </div>
                <div className='flex flex-col gap-[8px] max-w-[608px] min-w-[608px] justify-start '>
                    <div className='font-[700]'>聲明(Statement)</div>
                    <DropdownMenu options={['啟用', '不啟用']}
                        value={props.data?.registrationForm?.enableStatement ? '啟用' : '不啟用'}
                        select={(item, index) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), enableStatement: item === '啟用' })
                            }
                        }}
                    />
                    <textarea className='w-full p-[4px] border-[1px] border-[#8D876C] rounded-[4px] bg-[transparent] max-w-[600px]'
                        value={props.data?.registrationForm?.statement || ''}
                        onChange={(e) => {
                            if (props.onEdit) {
                                props.onEdit('registrationForm', { ...(props.data?.registrationForm || {}), statement: e.target.value })
                            }
                        }}
                    />
                </div>
            </div>


            {isShowPreview &&
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000080] flex items-center justify-center z-[9999]">
                    <div className="bg-white w-[90%] max-h-[90%] overflow-y-auto relative rounded-[8px]">
                        <EventFormDisplay
                            form={data}
                            id={eventId}
                        />
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer z-[10]" onClick={() => { setisShowPreview(false) }}>X</div>
                    </div>
                </div>}
            {isShowQrcode &&
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000080] flex items-center justify-center z-[9999]">
                    <div className="bg-white max-w-[90%] max-h-[90%] overflow-y-auto relative rounded-[8px]">
                        <div className="p-[16px]">
                            <div className="font-bold text-[24px] mb-[16px]">
                                報名表二維碼
                            </div>
                            <div className="mb-[16px]">
                                掃描以下二維碼以訪問報名表:
                            </div>
                            <div className="flex items-center justify-center mb-[16px]">
                                <div className='flex flex-col bg-white text-black text-[12px] items-center font-bold pb-[24px]'>
                                    <canvas ref={qrRef} />
                                </div>
                            </div>
                            <div className="text-[14px] mb-[16px]">
                                您可以將此二維碼保存或打印出來，方便參加者掃描。
                            </div>
                            <button className="px-[16px] py-[8px] bg-[#0F737E] text-white rounded-[4px] font-bold mb-[16px]"
                                onClick={() => {
                                    const canvas = qrRef.current;
                                    if (!canvas) return;
                                    canvas.toBlob((blob) => {
                                        const link = document.createElement('a');
                                        link.href = URL.createObjectURL(blob);
                                        link.download = `registration-form-${eventId}.png`;
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }, 'image/png');
                                }}
                            >
                                儲存二維碼
                            </button>
                            <div className="flex items-center justify-end">
                                <button className="px-[16px] py-[8px] bg-[#0F737E] text-white rounded-[4px] font-bold"
                                    onClick={() => {
                                        QRCode.toCanvas(qrRef.current, `${SHARE_BASE_URL}/registration-form/${eventId}`, { errorCorrectionLevel: 'H' })
                                            .then(() => {
                                                setisShowQrcode(false);
                                            })
                                            .catch(err => {
                                                console.error('Error generating QR code:', err);
                                            });
                                    }}
                                >
                                    關閉
                                </button>
                            </div>
                        </div>
                        <div className="absolute top-0 right-0 p-[8px] cursor-pointer z-[10]" onClick={() => { setisShowQrcode(false) }}>X</div>
                    </div>
                </div>
            }
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
